'use client';

import dynamic from 'next/dynamic';

export const RecentlyViewedCarouselDynamic = dynamic(
  () => import('./RecentlyViewedCarousel').then((mod) => mod.RecentlyViewedCarousel),
  {
    ssr: true,
    loading: () => <div className="h-145"></div>,
  },
);
